import React from 'react'

const MOCK = [
  'Cruise through iconic limestone karsts of Halong Bay',
  'Kayaking into hidden lagoons and sea caves',
  'Visit a traditional floating fishing village',
  'Fresh seafood meals prepared on board',
  'Sunrise Tai Chi session on the sundeck',
  'Guided cave exploration with expert naturalist',
  'Squid fishing under the stars',
  'Optional cooking class with our onboard chef',
]

export default function Highlights({ items }) {
  const list = items?.length ? items : MOCK

  return (
    <section className="si-section">
      <h2 className="ljn-section-title">Trip Highlights</h2>
      <div className="ljn-divider" style={{ marginBottom: 28 }} />
      <ul className="si-highlights">
        {list.map((item, i) => (
          <li key={i} className="si-highlight-item">
            <span className="si-highlight-item__dot" />
            {typeof item === 'object' ? item.label : item}
          </li>
        ))}
      </ul>
    </section>
  )
}
